import { useGetLegalGuardianDataQuery } from 'graphql/person/generates';
import { getGraphQLClient } from 'graphql/graphQLClient';

export const useGetLegalGuardianData = (personId: string) =>
  useGetLegalGuardianDataQuery(
    getGraphQLClient(),
    { personId },
    {
      enabled: !!personId,
      select: (response) => response,
    },
  );
